var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('full-load-list',{attrs:{"base-url":_vm.getListUrl(),"response-key":"event_invites"},scopedSlots:_vm._u([{key:"list",fn:function(slotProps){return [_c('event-invite',{attrs:{"invite":slotProps.result}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }